import React from 'react';
import { func, string } from 'prop-types';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';
import { LinkAsButton } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/LinkAsButton';
import { urls } from 'constants/urls';

// TODO: Merge this component with ../SignOut.js if possible
const SignOutButton = ({ className, onBlur, onClick, onFocus, width }) => {
  const { state: authState } = useAuthentication();

  const { isSignedOnAsCustomer, isLoggedIn: loggedIn } = authState;

  return loggedIn && !isSignedOnAsCustomer ? (
    <LinkAsButton
      className={className}
      component="a"
      data-testid="sign-out-link"
      data-test="signOut"
      href={urls.logout}
      label="Sign out"
      onBlur={onBlur}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
      onFocus={onFocus}
      theme="secondary"
      type="submit"
      width={width}
    />
  ) : null;
};

SignOutButton.propTypes = {
  className: string,
  onBlur: func,
  onClick: func,
  onFocus: func,
  width: string,
};

SignOutButton.defaultProps = {
  className: null,
  onBlur: null,
  onClick: null,
  onFocus: null,
  width: undefined,
};

SignOutButton.displayName = 'SignOutButton';

export default SignOutButton;
